import { WidgetProps } from './Widgets';
import DatePicker from 'react-datepicker';
import { useMemo } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { cn } from 'domain/core';

export const DatePickerComponent = ({
	value,
	className,
	onChange,
	variant,
}: WidgetProps<string> & {
	className?: string;
	variant?: 'small';
}) => {
	// Try to parse the date

	const now = new Date();
	const date = useMemo(() => {
		if (!value || Object.keys(value).length === 0) {
			return undefined;
		}

		const date = new Date(value ?? now);

		// Check if the date is valid
		if (date.toString() === 'Invalid Date') {
			return now;
		}
		return date ?? now;
	}, [value]);

	return (
		<div
			className={`flex w-full items-center justify-between ${className ?? ''}`}>
			<div
				className={cn(
					'w-full rounded-[4px] border border-gray-400 ' +
						(variant === 'small' ? 'p-[4px] text-sm' : 'p-[8px]')
				)}>
				<DatePicker
					dateFormat={'dd/MM/yyyy'}
					scrollableYearDropdown
					className='w-full bg-transparent'
					selected={date}
					onChange={(date) => {
						if (!date) {
							onChange('');
							return;
						}
						onChange((date || new Date()).toISOString());
					}}
				/>
			</div>
		</div>
	);
};
